import request from '@/utils/request'

export function getDept(params) {
    return request({
        url: 'dept',
        method: 'get',
        params
    })
}

export function getDepts(params) {
    return request({
        url: 'depts',
        method: 'get',
        params
    })
}

export function add(data) {
    return request({
        url: 'dept',
        method: 'post',
        data
    })
}

export function del(id) {
    return request({
        url: '/dept/' + id,
        method: 'delete'
    })
}

export function edit(data) {
    return request({
        url: 'dept',
        method: 'put',
        data
    })
}

/**
 * 获取两级树型数据
 * @param params
 */
export function getDeptTree(params) {
    return request({
        url: '/dept/tree',
        method: 'get',
        params
    })
}

export function getDeptAndChildrenTree(id) {
    return request({
        url: '/dept/tree/' + id,
        method: 'get'
    })
}
